import axiosIns from '@/utils/axios'

// 获取资讯类型
export function getInfoType () {
  // axiosIns.defaults.owner = '08'
  return axiosIns({
    url: `/api/category/list`,
    method: 'post'
  })
}

// 资讯列表查询
export function getInfoList (categoryNo, pageNo, pageSize, type) {
  // axiosIns.defaults.owner = '08'
  return axiosIns({
    url: `/api/push/getPushContentList?categoryNo=${categoryNo}&pageNo=${pageNo}&pageSize=${pageSize}&type=${type}`,
    method: 'get'
  })
}

// 获取资讯详情
export function getInfoContent (id) {
  // axiosIns.defaults.owner = '08'
  return axiosIns({
    url: `/api/push/${id}`,
    method: 'get'
  })
}

// 收藏资讯
export function infoCollect (params) {
  // axiosIns.defaults.owner = '08'
  return axiosIns({
    url: `/api/user/collect/collected`,
    method: 'post',
    params: params
  })
}

// 取消收藏资讯
export function cancelCollect (params) {
  // axiosIns.defaults.owner = '08'
  return axiosIns({
    url: `/api/user/collect/unCollected`,
    method: 'post',
    params: params
  })
}

// 获取最新资讯
export function getLatest (params) {
  // axiosIns.defaults.owner = '08'
  return axiosIns({
    url: `/api/push/latestNews`,
    method: 'post',
    params: params
  })
}

// 医院权限列表
export function hospitalAuthListAll () {
  return axiosIns({
    url: `/api/hospital/hospitalAuthListAll`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/information.js